export default __webpack_public_path__ + "91b0a9da.jpg";